import { combineReducers } from 'redux';

import patient from './auth/patient/reducer';
import funcionario from './auth/funcionario/reducer';
import doctor from './auth/doctor/reducer';
import prontuario from '../../redux/features/prontuario/prontuarioSlice';

export default combineReducers({
  patient,
  funcionario,
  doctor,
  prontuario,
});
